/**
 * Product IDs for subscription products across all republics
 * These IDs correspond to the products defined in Stripe/payment system
 */
export const STRIPE_PRODUCT_IDS = {
  ESSENTIAL_MONTHLY: 'prod_RqTbYsPalQ3AfM',
  ESSENTIAL_ANNUALLY: 'prod_RqTezToe62ITrO',
  PREMIUM_MONTHLY: 'prod_QkHK6SYqqUnkLC',
  PREMIUM_ANNUALLY: 'prod_QkHLnJhTVhERhy',
  WHOSCORED_PLUS_MONTHLY: 'prod_SsACNCOh4v7G84',
  GAZZETTA_PLUS_OFFER_1: 'prod_GZ_PLUS_OFFER_1',
  GAZZETTA_PLUS_OFFER_2: 'prod_GZ_PLUS_OFFER_2',
} as const;

export type ProductId = (typeof STRIPE_PRODUCT_IDS)[keyof typeof STRIPE_PRODUCT_IDS];
